export class UserInfoFacility {
  facilityId!: number;
  facilityName!: string;
  extClientFacilityId?: string;
  clientFacilityId?: number;
}
